import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import api from '@/api';
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  name: 'Generate',
  components: {},
  data: function data() {
    return {
      selectControlEnums: [],
      editControlEnums: [],
      tableControlEnums: [],
      initform: {
        rootPkg: 'com.unbox.admin',
        feignServiceName: 'admin-service',
        prefix: 'unbox_',
        tableName: '',
        tableComment: '',
        visitRoot: 'user',
        gateWayRoot: 'admin',
        apiVersion: 'v1',
        genSaveType: 1,
        deleteType: 1
      },
      data: {},
      tableData: [],
      options: [{
        value: 'eq',
        label: 'eq'
      }, {
        value: 'like',
        label: 'like'
      }, {
        value: '',
        label: '忽略'
      }],
      sortOptions: [{
        value: 'asc',
        label: 'asc'
      }, {
        value: 'desc',
        label: 'desc'
      }, {
        value: '',
        label: '忽略'
      }]
    };
  },
  methods: {
    initSelectControlEnumsApi: function initSelectControlEnumsApi() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return api.GET_ENUMERATION_LIST({
                name: 'gen_select_control'
              });
            case 1:
              res = _context.v;
              _this.selectControlEnums = res.body;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    initEditControlEnumsApi: function initEditControlEnumsApi() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return api.GET_ENUMERATION_LIST({
                name: 'gen_edit_control'
              });
            case 1:
              res = _context2.v;
              _this2.editControlEnums = res.body;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    initTableControlEnumsApi: function initTableControlEnumsApi() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return api.GET_ENUMERATION_LIST({
                name: 'gen_table_control'
              });
            case 1:
              res = _context3.v;
              _this3.tableControlEnums = res.body;
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    initTableData: function initTableData(data) {
      this.data = data;
      this.initform.tableName = data.tableName;
      this.initform.tableComment = data.tableComment;
      this.getData();
    },
    getData: function getData() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var data;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return api.GET_TABLE_INFO(_this4.data);
            case 1:
              data = _context4.v;
              data.body.forEach(function (element) {
                element.queryType = 'eq';
                element.sortType = '';
                element.webSelectFlug = false;
                element.webTableListFlug = false;
                element.webEditFlug = false;
                element.webSortTableDisPlayNum = 0;
              });
              _this4.tableData = data.body;
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    handleClose: function handleClose() {
      this.$emit('close');
    },
    generate: function generate(type) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              localStorage.setItem('tableConfig', JSON.stringify(_this5.initform));
              _this5.initform.generateInfos = _this5.tableData;
              _this5.initform.type = type;
              _context5.n = 1;
              return api.GENERATE(_this5.initform);
            case 1:
              _this5.$message.success('生成成功');
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    }
  },
  created: function created() {
    var tableConfig = localStorage.getItem('tableConfig');
    if (tableConfig !== null) {
      this.initform = JSON.parse(tableConfig);
    }
    this.initEditControlEnumsApi();
    this.initSelectControlEnumsApi();
    this.initTableControlEnumsApi();
  }
};